// v10/src/services/reportsService.js
//
// Wrapper de los endpoints de reportes PDF/Excel del backend (Reportes parte 1).
// Llama al backend con responseType:'blob', extrae el filename del header
// Content-Disposition cuando viene, y dispara la descarga en el navegador
// vía un <a download> efímero.

import api from './apiService';

async function downloadReport(endpoint, body, defaultFilename) {
  const response = await api.post(endpoint, body, { responseType: 'blob' });

  const contentDisposition = response.headers?.['content-disposition'] || '';
  const match    = contentDisposition.match(/filename="?([^"]+)"?/i);
  const filename = match ? match[1] : defaultFilename;

  const blob = new Blob(
    [response.data],
    { type: response.headers?.['content-type'] || 'application/octet-stream' },
  );
  const url = window.URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href     = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Pequeño delay para que el browser inicie la descarga antes de revocar.
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

export const reportsService = {
  // params: { format: 'pdf'|'xlsx', period_type: 'month'|'range', month?, year?, from?, to? }
  async maintenance(params) {
    const ext = params?.format === 'xlsx' ? 'xlsx' : 'pdf';
    await downloadReport('/api/reports/maintenance', params, `mantenimiento.${ext}`);
  },

  // params: { format: 'pdf'|'xlsx', from?, to? }
  async stockMovements(params) {
    const ext = params?.format === 'xlsx' ? 'xlsx' : 'pdf';
    await downloadReport('/api/reports/stock-movements', params, `stock.${ext}`);
  },

  // params: { format: 'pdf'|'xlsx', period_type: 'month'|'range', month?, year?, from?, to? }
  async fuelConsumption(params) {
    const ext = params?.format === 'xlsx' ? 'xlsx' : 'pdf';
    await downloadReport('/api/reports/fuel-consumption', params, `combustible.${ext}`);
  },

  // params: { format: 'pdf'|'xlsx', user_id?, period_type: 'month'|'range'|'all', month?, year?, from?, to? }
  // Si no se pasa user_id, el backend usa el id del usuario autenticado.
  async logbook(params) {
    const ext = params?.format === 'xlsx' ? 'xlsx' : 'pdf';
    await downloadReport('/api/reports/logbook', params, `logbook.${ext}`);
  },

  // Manual de uso (PDF). Filtra secciones por rol del usuario autenticado.
  // lang: 'es' | 'en' (default 'es'). Es un GET, no POST.
  async manual(lang = 'es') {
    const normalized = lang === 'en' ? 'en' : 'es';
    const response = await api.get(`/api/reports/manual?lang=${normalized}`, {
      responseType: 'blob',
    });
    const contentDisposition = response.headers?.['content-disposition'] || '';
    const match    = contentDisposition.match(/filename="?([^"]+)"?/i);
    const filename = match ? match[1] : `Condor360_Manual.${normalized}.pdf`;

    const blob = new Blob(
      [response.data],
      { type: response.headers?.['content-type'] || 'application/pdf' },
    );
    const url = window.URL.createObjectURL(blob);
    const a   = document.createElement('a');
    a.href     = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  },
};

export default reportsService;
